import { buildMatchPath } from "pages/PageConfigs";
import { MatchContainer } from "./styles";
import { MatchTime } from "./Parts/MatchTime/MatchTime";
import { MatchTeams } from "./Parts/MatchTeams/MatchTeams";
import { Match } from "model/Match/Match";
import { matchHasStarted } from "model/Match/MatchStatus";
import { PlainNavLink } from "styles/elements";

interface Props {
  match: Match;
  tournamentId: string;
}

export const CompactMatchListItem = ({ match, tournamentId }: Props) => {
  const isTimeAttack = match.sets.some((s) => s.type === "TimeAttack");
  const showScore = !isTimeAttack && matchHasStarted(match);

  return (
    <PlainNavLink to={buildMatchPath(match.id)}>
      <MatchContainer>
        {!isTimeAttack && (
          <MatchTeams
            match={match}
            tournamentId={tournamentId}
            showScore={showScore}
          />
        )}
        {!showScore && (
          <MatchTime timeMs={match.startTimeMs} isDelayed={match.isDelayed} />
        )}
      </MatchContainer>
    </PlainNavLink>
  );
};
